<form [formGroup]="form" class="table-options">
  <div class="form-container container">
    <div>
      <mat-label>{{ "Templates.Input" | translate }}</mat-label>
      <div class="editor-container">
        <quill-editor
          formControlName="input"
          [modules]="quillModules"
          class="full-width"
        ></quill-editor>
      </div>
    </div>
    <div>
      <mat-label>{{ "Templates.Output" | translate }}</mat-label>
      <div class="editor-container">
        <quill-editor
          formControlName="output"
          [modules]="quillModules"
          class="full-width"
        ></quill-editor>
      </div>
    </div>
    <button
      class="mt-1"
      mat-raised-button
      color="primary"
      (click)="saveExample()"
      [disabled]="loading || form.invalid"
    >
      {{ "Templates.SaveButton" | translate }}
    </button>

    <button
      class="mt-1"
      mat-raised-button
      color="primary"
      (click)="cancelAction()"
      [disabled]="loading"
    >
      {{ "Templates.CancelButton" | translate }}
    </button>

    <button
      class="mt-1"
      mat-raised-button
      color="primary"
      (click)="deleteAction()"
      [disabled]="loading"
    >
      {{ "Global.Delete" | translate }}
    </button>
  </div>
</form>
